import './../../../../components/common/v2/Styles/__styles.css';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  Stack,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ReactNode } from 'react';
import LosText from './LosText';

export interface LosSelectOption {
  value: string;
  label: string;
  icon?: JSX.Element;
}

interface LosSelectProps {
  placeholder?: string;
  hideDropDownIcon?: boolean;
  dropDownIcon?: ReactNode;
  options?: LosSelectOption[];
  renderOptions?: () => ReactNode;
  renderSelectedValue?: (selected: string) => ReactNode;
  hidePlaceholder?: boolean;
}

const StyledPlaceholder = styled(LosText)(({ theme }) => {
  return {
    fontSize: '0.8125rem',
    fontFamily: 'Aspekta !important',
    fontWeight: 450,
    lineHeight: '120%',
  };
});

function LosSelect({
  options,
  placeholder,
  renderOptions,
  renderSelectedValue,
  hideDropDownIcon,
  hidePlaceholder = false,
  ...rest
}: LosSelectProps & SelectProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const getLabelForSelectedValue = (selected: string) => {
    const selectedOption =
      options?.filter((item) => item.value == selected) ?? [];
    if (selectedOption.length > 0) {
      return selectedOption[0].label;
    }
    return selected;
  };

  return (
    <FormControl>
      {rest.label && (
        <InputLabel
          size="small"
          sx={{ color: '#AFAFAF' }}
          htmlFor={rest.labelId}
        >
          {rest.label}
        </InputLabel>
      )}
      <Select
        {...rest}
        sx={{
          borderRadius: '.5rem',
          maxHeight: '40px',

          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderColor: theme.palette.grey[400],
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderColor: theme.palette.grey[400],
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderColor: theme.palette.grey[400],
          },
          ...(isMobile == false && {
            backgroundColor: 'white',
          }),
          ...rest.sx,
        }}
        displayEmpty
        // inputProps={{ 'aria-label': 'Without label' }}
        IconComponent={hideDropDownIcon ? () => null : undefined}
        renderValue={(selected: any) => {
          if (
            hidePlaceholder == false &&
            (!selected || selected?.length <= 0)
          ) {
            return (
              <StyledPlaceholder text={placeholder ?? ''} variant="caption" />
            );
          }
          if (renderSelectedValue) {
            return renderSelectedValue(selected);
          }
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                height: '30px',
              }}
            >
              <LosText
                text={getLabelForSelectedValue(selected)}
                style={{ fontSize: '13px', lineHeight: '120%' }}
              />
            </div>
          );
        }}
      >
        {renderOptions && renderOptions()}
        {options?.map((option, index) => {
          return (
            <MenuItem
              key={index}
              value={option.value}
              style={{ fontFamily: 'Aspekta !important' }}
            >
              <Stack direction={'row'} gap={2} alignItems="center">
                {option.icon && option.icon}
                <LosText style={{ fontSize: '14px' }}>{option.label}</LosText>
              </Stack>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default LosSelect;
